<script setup lang="ts">
import type { NuxtError } from '#app'

import amplitudeConfig from '@config/amplitude.json'

import { trackEvent } from '@tools/amplitude'

import errorImage from '@assets/images/error/error-illustration.svg'

import HeadingH4 from '@UI/Typography/HeadingH4.vue'
import TextSecondary from '@UI/Typography/TextSecondary.vue'
import BtnPrimary from '@UI/Buttons/BtnPrimary.vue'

defineOptions({
  name: 'PageError',
})

const props = defineProps<{
  error: () => NuxtError
}>()

trackEvent(amplitudeConfig.events.pageNotFound, {
  error: String(props.error),
})

</script>

<template>
  <div class="error-page">
    <div class="error-page__image-wrapper">
      <img
        :src="errorImage"
        alt="Error illustration"
        class="error-page__image"
      >
    </div>

    <div class="error-page__content">
      <div class="error-page__text-wrapper">
        <HeadingH4>
          Oops...something went wrong 👀
        </HeadingH4>

        <TextSecondary>
          Accidents happen, but feel free to go back to the home page and try again
        </TextSecondary>
      </div>

      <BtnPrimary
        text="Go back to home page"
        @click="$router.push('/')"
      />
    </div>
  </div>
</template>

<style scoped lang="scss" src="@scss/pages/error.scss" />
